import { type ReactElement } from 'react'
import { Group, Text } from '@mantine/core'
import { useTranslation } from '@front/model'
import { MaterialSymbolIcon } from '../../../../terros/icon/MaterialSymbolIcon'

export const HiddenChildrenIndicator = ({ count }: { count: number }): ReactElement => {
  const { t } = useTranslation()

  return (
    <Group gap='xs' wrap='nowrap' className='pointer-events-none h-[18px]'>
      {count > 0 && (
        <>
          <MaterialSymbolIcon icon='expand_more' size='sm' />
          <Text c='dimmed' size='xs'>
            {count === 1 ? t('{{count}} child', { count }) : t('{{count}} children', { count })}
          </Text>
        </>
      )}
    </Group>
  )
}
